import React from 'react';
import type { FamilyDefinition } from '../../content';
import { Badge } from '../../components/ui/Badge';
import { MasteryRing } from '../../portals/shared/MasteryRing';
import { CardSurface } from '../shared/CardSurface';
import { MasteryProgressBar } from '../shared/MasteryProgressBar';
import { levelBadgeLabel } from './levelLabel';
interface FamilyCardProps {
  family: FamilyDefinition;
  masteryScore: number;
  attempts: number;
  index: number;
  learnerGroup: number;
  onSelect: (id: string) => void;
}
export function FamilyCard({
  family,
  masteryScore,
  attempts,
  index,
  learnerGroup,
  onSelect
}: FamilyCardProps) {
  // Toonde de ruwe leerlijncode ("M6", "E6"). Zie levelLabel.ts.
  const levelLabel = levelBadgeLabel(family.levelCode, learnerGroup);
  return <CardSurface initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2,
    ease: [0.23, 1, 0.32, 1],
    // Gecapt op 120ms: met tientallen onderwerpen in een vak liep de oude
    // stagger op tot 300ms, en dan komt de onderste kaart merkbaar te laat
    // terwijl een kind al aan het scrollen is.
    delay: Math.min(index * 0.02, 0.12)
  }} onClick={() => onSelect(family.familyId)} className="w-full p-3.5 rounded-2xl border-2 border-slate-200 bg-white hover:border-indigo-300 hover:shadow-lg transition-colors group overflow-hidden flex flex-col h-full" data-id="element-2979" data-mp="35kasaqzg6krp">
      
      <header className="flex items-start justify-between mb-2 w-full" data-id="element-2980" data-mp="3v4l73dplg11i">
        <div className="flex-1 min-w-0 pr-2" data-id="element-2981" data-mp="3q6td8e5e24uo">
          <h4 className="text-sm font-black text-slate-800 leading-tight line-clamp-2 group-hover:text-indigo-700 transition-colors" data-id="element-2982" data-mp="3q60gm6058vq9">
            {family.description}
          </h4>
          <div className="flex items-center gap-1.5 mt-1.5" data-id="element-2983" data-mp="3s0dj76bd6ou">
            {levelLabel && <Badge variant="neutral" size="sm" data-id="element-2984" data-mp="hq71nvlgnsbb">
                {levelLabel}
              </Badge>}
            <span className="text-[10px] text-slate-400 font-medium truncate" data-id="element-2985" data-mp="cs5gn54h5ix7">
              {family.skill}
            </span>
          </div>
        </div>
        <div className="flex-shrink-0" data-id="element-2986" data-mp="36hioww1pa5jd">
          <MasteryRing score={masteryScore} size={40} data-id="element-2987" data-mp="3bi6qgbnk24ru" />
        </div>
      </header>

      <div className="mt-auto pt-2 w-full" data-id="element-2988" data-mp="3fkju8uiqrslz">
        <MasteryProgressBar masteryScore={masteryScore} caption={attempts > 0 ? `${attempts}× geoefend` : undefined} data-id="element-2989" data-mp="3fji89v06tlph" />
        
      </div>
    </CardSurface>;
}